import React from 'react';

import Helmet from 'react-helmet';
import { useTitle } from 'ha/helpers/hooks/useTitle';
import { HermesInfo, LinkData, SitemapStatus } from 'ha/modules/Hermes/types';
import { useIntl } from 'ha/i18n';

interface Props {
  metaTitle: string;
  socialNetworkTitle?: string;
  metaDescription: string;
  linkData?: LinkData[];
  titleTemplateOn?: boolean;
  info?: HermesInfo;
}

const HermesMeta: React.FC<Props> = ({
  metaTitle,
  socialNetworkTitle,
  metaDescription,
  linkData,
  titleTemplateOn = true,
  info,
}) => {
  const title = useTitle(metaTitle, { withSuffix: titleTemplateOn });
  const { urlResolver } = useIntl();

  const isExcluded = info?.sitemap && info.sitemap === SitemapStatus.EXCLUDE;

  return (
    <Helmet>
      <title key="title">{title}</title>
      <meta
        key="meta og:title"
        property="og:title"
        content={socialNetworkTitle || metaTitle}
      />
      <meta
        key="meta description"
        name="description"
        content={metaDescription}
      />
      <meta
        key="meta og:description"
        property="og:description"
        content={metaDescription}
      />
      {linkData && !isExcluded ? (
        linkData.map(linkProps => (
          <link
            {...linkProps}
            href={urlResolver.absolutizePath(linkProps.href, {
              skipAddLanguage: true,
            })}
            key={`link ${linkProps.rel}${
              linkProps.rel === 'alternate' ? ` ${linkProps.hrefLang}` : ''
            }`}
          />
        ))
      ) : (
        <meta key="meta robots" name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

export { HermesMeta };
